import { render, staticRenderFns } from "./SectionList.vue?vue&type=template&id=cb16adbe"
import script from "./SectionList.vue?vue&type=script&lang=ts"
export * from "./SectionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports